import firebase from "firebase";
import { toast } from "react-toastify";

export const getBrandAmbassodarContests = (uid, lastDocument, onSuccess) => {
  return async (dispatch) => {
    try {
      let querya = await firebase
        .firestore()
        .collection("contest")
        .where("contestType", "==", "Brand Ambassador Contest");
      if (lastDocument != "") {
        querya = querya.startAfter(lastDocument);
      }
      querya
        .limit(5)
        .get()
        .then(async (query) => {
          let temp_data = [];
          for (const doc of query.docs) {
            const docData = doc.data();
            const enrolledSnapShot = await firebase
              .firestore()
              .collection("contest_enrollment")
              .where("athlete_id", "==", uid)
              .where("contest_id", "==", doc.id)
              .get();

            if (enrolledSnapShot.empty) {
              temp_data.push({ id: doc.id, ...docData, enrolled: false });
            } else {
              temp_data.push({
                id: doc.id,
                ...docData,
                contestEnrollmentId: enrolledSnapShot.docs[0].id,
                contestEnrollmentStatus: enrolledSnapShot.docs[0].data().status,
                enrolled: true,
              });
            }
          }

          dispatch({
            type: lastDocument
              ? "GET_BRAND_AMBASSODAR_CONTEST_MORE"
              : "GET_BRAND_AMBASSODAR_CONTEST",
            payload: {
              data: temp_data,
              lastDocument: query.docs[temp_data.length - 1],
              hasMoreDocument: temp_data.length >= 5,
            },
          });
          onSuccess();
        });
    } catch (error) {
      console.error("Error getting contests: ", error);
      dispatch({ type: "GET_CONTEST_ERROR", payload: error.message });
      onSuccess();
    }
  };
};

export const deleteContestEnrollment = (
  Id,
  contestId,
  contestDocId,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      const querySnapshot = await firebase
        .firestore()
        .collection("contest_enrollment")
        .where("athlete_id", "==", Id)
        .where("contest_id", "==", contestId)
        .get();

      querySnapshot.forEach(async (doc) => {
        await firebase
          .firestore()
          .collection("contest_enrollment")
          .doc(doc.id)
          .delete();
      });
      if (contestDocId) {
        const querySnapshot1 = await firebase
          .firestore()
          .collection("contest_videos")
          .where("contestEnrollmentId", "==", contestDocId)
          .get();

        querySnapshot1.forEach(async (doc) => {
          await firebase
            .firestore()
            .collection("contest_videos")
            .doc(doc.id)
            .delete();
        });
      }
      onSuccess();
    } catch (error) {
      console.error("Error deleting contest enrollment: ", error);
    }
  };
};
export const getParticipantList = (participantList, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      const tempData = [];
      for (const participant of participantList) {
        const query = await firebase
          .firestore()
          .collection("users")
          .doc(participant)
          .get();
        const data = query.data();

        tempData.push({
          athlete_id: query.id,
          athleteId: data.athleteID,
          athleteName: data.first_name + " " + data.last_name,
          email: data.email,
        });
      }
      onSuccess(tempData);
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
};

export const updateContestAthleteList = (
  contestId,
  athleteList,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      const contestRef = firebase
        .firestore()
        .collection("contest")
        .doc(contestId);
      await contestRef.update({
        participantList: athleteList,
      });
      onSuccess("Success");
    } catch (error) {
      onSuccess("Error");
      console.error("Error updating contest document:", error);
    }
  };
};

export const checkEnrollementStatus = (uid, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      let data = [];
      const enrolledSnapShot = await firebase
        .firestore()
        .collection("contest_enrollment")
        .where("athlete_id", "==", uid)
        .get();

      if (!enrolledSnapShot.empty) {
        for (const doc of enrolledSnapShot.docs) {
          const docData = doc.data();
          const contestSnapshot = await firebase
            .firestore()
            .collection("contest")
            .doc(docData.contest_id)
            .get();
          const contestData = contestSnapshot.data();
          data.push(contestData.status);
        }
      }
      onSuccess(data);
    } catch (e) {
      console.error("Error checking enrollment status: ", e);
    }
  };
};

export const addContestEnrollment =
  (data, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      const query = await firebase
        .firestore()
        .collection("contest_enrollment")
        .add(data);

      const contestEnrollmentId = query.id;

      await firebase.firestore().collection("fan_notifications").add({
        athleteId: data.athlete_id,
        createdAt: firebase.firestore.Timestamp.now(),
        isRead: [],
        type: "talking_contest",
      });

      onSuccess(contestEnrollmentId);
    } catch (error) {
      onSuccess();
      console.error("Error adding contest enrollment:", error);
    }
  };

export const addAthleteData = (Id, contestId, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      const athleteDataRef = await firebase
        .firestore()
        .collection("contest_enrollment")
        .where("athlete_id", "==", Id)
        .where("contest_id", "==", contestId)
        .get();

      athleteDataRef.forEach(async (doc) => {
        try {
          const newAthleteDataRef = await firebase
            .firestore()
            .collection("contest_enrollment")
            .doc(doc.id)
            .collection("athlete_Data")
            .add({ success: true });
          await firebase
            .firestore()
            .collection("contest_enrollment")
            .doc(doc.id)
            .update({
              athlete_data: newAthleteDataRef.id,
            });
        } catch (error) {
          console.error("Error adding athlete data: ", error);
        }
      });

      onSuccess();
    } catch (error) {
      console.error("Error querying contest enrollment: ", error);
    }
  };
};

export const addContestVideo = (data, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("contest_videos")
        .add(data)
        .then((query) => {
          if (query.id) {
            onSuccess(query.id);
          } else {
            toast.error(`Unexpected Error Occur`);
          }
        });
      onSuccess();
    } catch (error) {
      console.error("Error querying contest enrollment: ", error);
    }
  };
};

export const getContestVideoData = (contestId, id, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      const contestVideosRef = await firebase
        .firestore()
        .collection("contest_videos")
        .where("contest_id", "==", contestId)
        .where("athleteId", "==", id)
        .get();
      if (contestVideosRef.empty) {
        onSuccess(null);
        return;
      }
      contestVideosRef.forEach(async (doc) => {
        const contestVideoData = doc.data();
        if (contestVideoData) {
          let tempData = {
            id: doc.id,
            videoUrl: contestVideoData.videoUrl,
            participantList: [],
          };

          for (const participantId of contestVideoData.participantList) {
            const participantDoc = await firebase
              .firestore()
              .collection("users")
              .doc(participantId)
              .get();
            const participantData = participantDoc.data();
            tempData.participantList.push({
              athleteId: participantData.athleteID,
              athlete_Id: participantDoc.id,
              athleteName:
                participantData.first_name + " " + participantData.last_name,
            });
          }

          onSuccess(tempData);
        } else {
          toast.error(`Unexpected Error Occurred`);
        }
      });
    } catch (error) {
      console.error("Error querying contest videos: ", error);
    }
  };
};

export const updateContestVideoData = (Id, data, onSuccess = () => {}) => {
  return async (dispatch) => {
    try {
      const contestVideosRef = firebase
        .firestore()
        .collection("contest_videos")
        .doc(Id);

      await contestVideosRef.update({
        participantList: data.participantList,
        videoUrl: data.videoUrl,
      });

      onSuccess();
    } catch (error) {
      console.error("Error updating contest videos: ", error);
    }
  };
};
export const getSportContestData =
  (Id, lastDocument, onSuccess) => async (dispatch) => {
    try {
      let querya = await firebase
        .firestore()
        .collection("contest")
        .where("participantList", "array-contains", Id)
        .where("status", "in", ["completed", "rewarded"]);
      if (lastDocument != "") {
        querya = querya.startAfter(lastDocument);
      }
      querya
        .limit(10)
        .get()
        .then(async (query) => {
          let temp_data = [];
          for await (let doc of query.docs) {
            temp_data.push({
              ...doc.data(),
              id: doc.id,
            });
          }
          dispatch({
            type: lastDocument
              ? "GET_SPORT_CONTEST_DATA_MORE"
              : "GET_SPORT_CONTEST_DATA",
            payload: {
              data: temp_data,
              lastDocument: query.docs[temp_data.length - 1],
              hasMoreDocument: temp_data.length >= 10,
            },
          });
          onSuccess();
        });
    } catch (error) {
      console.error(error);
    }
  };
